import { render, staticRenderFns } from "./recordMgr.vue?vue&type=template&id=4655f30c&"
import script from "./recordMgr.vue?vue&type=script&lang=js&"
export * from "./recordMgr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports